module.exports = __webpack_public_path__ + "img/interior-sample-2.a65624f7.jpg";